import Patrol from "../fragments/patrol";

export default `
query QueryPatrolsByPropertyIdStartTimeIndex($propertyId: String!, $startTime: Float, $to: Float, $after: String) {
  queryPatrolsByPropertyIdStartTimeIndex(
    propertyId: $propertyId, 
    startTime: $startTime, 
    to: $to, 
    after: $after
  ) {
    items ${Patrol}
    nextToken
  }
}
`;
